import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/signup/loading';

export const Route = createFileRoute('/_public/signup/')({
  pendingComponent: Loading,
});
